(function(){
    'use strict';

    const facetsElement = document.querySelector('.sidenav__search--filters');
    const resultsElement = document.querySelector('#search-results');
    const showResults = document.querySelector('.modal-search__apply');
    const fbBaseURL = "https://mqu-dev-search.squiz.cloud/s/search.json";
    const fbParams = "?collection=mq-micro-credentials-web&query=%21padre&profile=_default&form=json&sort=";
    var finalFBUrl = fbBaseURL + fbParams;
    
    if(resultsElement && window.isLocal()) {

        function searchResult(data) {
            buildFacets(data.response.facets);
            buildResults(data.response.resultPacket.results);
            buildResultCountPagination(data.response.resultPacket.resultsSummary,data.response.resultPacket.query);
        }
    
        function buildResultCountPagination(count,query) {
            const resultCountElement = document.querySelector("#resultcount");
            
            const resultPaginationElement = document.querySelector('#result-pagination');
            resultPaginationElement.innerHTML = '';
            const totalMatching = count.totalMatching;
            const numRanks = count.numRanks;
            const totalPages = Math.ceil(totalMatching / numRanks);
            const currStart = count.currStart;
            const currEnd = count.currEnd;
    
            resultCountElement.innerHTML = `
            <strong>${currStart} - ${currEnd}</strong> of <strong>${totalMatching}</strong> results 
            ${query !== '!padre' ? 'for <strong>'+query+'</strong>' : ''}        
            `;
            showResults.querySelector('span').innerHTML = `(${totalMatching})`;
    
            if(currStart === 0) {
                resultsElement.innerHTML = "<h3>No search results found.</h3>";
            }
    
            if(totalPages > 1) {
                const prevStart = count.prevStart;
                const nextStart = count.nextStart;
                const currPage = Math.ceil(currStart / numRanks);
                const url = new URL(finalFBUrl);
                const params = new URLSearchParams(url.search);
                if(currPage>1) {
                    params.set('start_rank',prevStart);
                    resultPaginationElement.innerHTML += `
                    <li class="pagination__arrow"><button type="button" data-url="?${params.toString()}"><i class="ico ico--md ico--f-chevron-l-s is-disabled"></i></button></li>
                    `;
                }
                for(let i=1;i<=totalPages;i++){
                    if(currPage === i) {
                        resultPaginationElement.innerHTML += `
                        <li class="pagination__button flex flex--center is-active"><button type="button">${i}</button></li>
                        `;
                    }else{
                        params.set('start_rank',(i-1)*numRanks + 1);
                        resultPaginationElement.innerHTML += `
                        <li class="pagination__button flex flex--center"><button type="button" data-url="?${params.toString()}">${i}</button></li>
                        `;
                    }
                }    
                if(currPage<totalPages) {
                    params.set('start_rank',nextStart);
                    resultPaginationElement.innerHTML += `
                    <li class="pagination__arrow"><button type="button" data-url="?${params.toString()}"><i class="ico ico--md ico--f-chevron-r-s "></i></button></li>
                    `;
                }
                activatePagination();
            }
        }
    
        function buildResults(results) {
            let resultsHTML = "";
            resultsElement.innerHTML = "";
            results.forEach(result=>{
                resultsHTML += `
                <div class="story full-width reset-height">
                    <div class="flex flex--space flex--md-row flex--align-start">
                        <div class="flex order-md--1 margin--16">
                            <div class="tag tag--light-secondary margin-right--6 margin-btm--0">Micro-credential</div>
                        </div>
                    </div><a href="${result.liveUrl}" class="h3 flex pad-right-wrap--16 flex--align-start" data="title">${result.title.replace(' | MQU Micro Credentials eCommerce','')}</a>
                    <p>${result.summary}</p>
                `;
                resultsHTML += `
                    <ul>
                `;
                const obj = result.metaData;
                const sortedMetadata = Object.keys(obj).sort().reduce((accumulator, key) => {accumulator[key] = obj[key];return accumulator;}, {});
                for(const metadataKey in sortedMetadata){
                    if(metadataKey !== 'title') {
                        resultsHTML += `
                            <li><strong>${metadataKey.replace('course','').replace('StartDate','Start Date')}: </strong>${sortedMetadata[metadataKey]}</li>
                        `;
                    }
                };
                resultsHTML += `
                    </ul>
                </div>
                `;
            });
            resultsElement.innerHTML += resultsHTML;
        }
        function buildFacets(facets) {
            facetsElement.innerHTML = "";
            const selectedFilter = document.querySelector('ul[data=selected-filters]');
            selectedFilter.innerHTML = "";
            let facetsHTML = "";
            facets.forEach( (facet,idx) => {
            if(facet.name && facet.categories && facet.categories.length) {
                    facetsHTML = `
                        <li class="is-active">
                            <div class="flex flex--space sidenav__search--container" role="button" tabindex="${idx}">
                                <p class="h5">${facet.name}</p><i class="ico ico--md ico--f-caret-r"></i>
                            </div>
                            <ul class="sidenav__search--filter">
                        `;
                                facet.categories.forEach(category=>{
                                    category.values.forEach(val=>{
                                    const rdn = Math.floor(100000 + Math.random() * 900000);
                                    if(val.selected === true) {
                                        buildFilters(val.label,val.toggleUrl);
                                    }
                                    facetsHTML += `
                                    <li class="form__checkbox"><input type="checkbox" id="${rdn}" value="${val.toggleUrl}" ${val.selected ? "checked" : ""}>
                                        <div class="full-width margin-left--8"><label class="flex flex--align-start" for="${rdn}">
                                                <p>${val.label}</p><span>(${val.count})</span>
                                            </label></div>
                                    </li>
                                    `; 
                                });
                                });
                                facetsHTML += `
                            </ul>
                        </li>
                    `;
                    facetsElement.innerHTML += facetsHTML;
                }
            });
            activateDropdown();
            activateCheckbox();
            activateFilters();
        }
    
        function buildFilters(label,url){
            const selectedFilter = document.querySelector('ul[data=selected-filters]');
            selectedFilter.insertAdjacentHTML('beforeend',`<li><button type="button" data-url="${url}" class="tag tag--dark">${label}<i class="ico ico--sm ico--f-close-s"></i></button></li>`);
        }
    
        function activatePagination(){
            const pagination = document.querySelector('#result-pagination');
            pagination.querySelectorAll('button').forEach(pButton=>{
                pButton.addEventListener('click',()=>{
                    fetchResult(fbBaseURL+pButton.dataset.url);
                });
            });
        }
    
        function activateFilters(){
            const selectedFilter = document.querySelector('ul[data=selected-filters]');            
            selectedFilter.querySelectorAll('button').forEach(fButton=>{
                fButton.addEventListener('click',()=>{
                    fetchResult(fbBaseURL+fButton.dataset.url);
                });
            });
        }
    
        function activateDropdown(){
            const containers = document.querySelectorAll('.sidenav__search--container');
            containers.forEach( container=> {
                container.addEventListener('click', ()=> {
                    container.parentElement.classList.toggle('is-active');
                });
            })
        }
    
        function activateCheckbox() {
            const allCheckboxes = document.querySelectorAll('.sidenav__search--filters input');
            allCheckboxes.forEach(checkbox => {
                checkbox.addEventListener('click', ()=> {
                    fetchResult(fbBaseURL+checkbox.value);
                });
            });        
        }
    
        function fetchResult(url) {
            document.querySelector('#query').innerText = url;
            finalFBUrl = url;
            fetch(url)
            .then(response => response.json())
            .then(data => searchResult(data));
        }
    
        const inputForm = document.querySelector('#global-search');
        const inputField = inputForm ? inputForm.querySelector('#global-search-input') : '';
        inputForm ? inputForm.addEventListener('submit', (e)=>{
            e.preventDefault();
            if(inputField.value.trim().length > 1) {
                const url = new URL(finalFBUrl);
                let params = new URLSearchParams(url.search);
                params.set('query',inputField.value);
                fetchResult(fbBaseURL + "?" + params.toString());
            }
        }) : '';

        const submitButton = document.querySelector('.global-search-submit');
        submitButton ? submitButton.addEventListener('click',()=>{
            if(inputField.value.trim().length > 1) {
                const url = new URL(finalFBUrl);
                let params = new URLSearchParams(url.search);
                params.set('query',inputField.value);
                fetchResult(fbBaseURL + "?" + params.toString());
            }
        }) : '';


        const sortDropdown = document.querySelector('.dropdown-sorting');
        sortDropdown ? sortDropdown.querySelectorAll('ul button').forEach(dButton=>{
            dButton.addEventListener('click',()=>{
                const url = new URL(finalFBUrl);
                const params = new URLSearchParams(url.search);
                params.set('sort',dButton.dataset.url);
                fetchResult(fbBaseURL + "?" + params.toString());
            });
        }) : '';

        const mobileModal = document.querySelector('.mobile-search-modal');
        mobileModal ? mobileModal.addEventListener('click', ()=>{
            document.querySelector('aside.sidenav__search').classList.toggle('is-active');
        }) : '';

        const clearAll = document.querySelector('.clear-all');
        clearAll ? clearAll.addEventListener('click',()=>{
            fetchResult(fbBaseURL+fbParams);
        }) : '';
    
    
        fetchResult(finalFBUrl);
    }
    
}());
